import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactMarkdown from 'react-markdown';

export const SR_MARKDOWN_THEME_LEGAL = 'legal';
export const SR_MARKDOWN_THEME_PROPERTY_FEATURES = 'propertyFeatures';
export const SR_MARKDOWN_THEME_GREYCLIFF = 'greycliff';

const SrMarkdown = ({ source, theme, escapeHtml, onRef }) => {
  return (
    <div ref={onRef} className={classnames('SrMarkdown', theme)}>
      <ReactMarkdown source={source} escapeHtml={escapeHtml} />
    </div>
  );
};

SrMarkdown.propTypes = {
  source: PropTypes.string.isRequired,
  theme: PropTypes.oneOf([
    SR_MARKDOWN_THEME_LEGAL,
    SR_MARKDOWN_THEME_PROPERTY_FEATURES,
    SR_MARKDOWN_THEME_GREYCLIFF,
  ]),
  escapeHtml: PropTypes.bool,
  onRef: PropTypes.func,
};

SrMarkdown.defaultProps = {
  theme: SR_MARKDOWN_THEME_LEGAL,
};

SrMarkdown.displayName = 'SrMarkdown';

export default SrMarkdown;
